import { useLocation, useSearchParams, Link, useLoaderData, Outlet } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import ServerFooter from "../common/ServerFooter";
import { Organization } from "./types";
//--------------------------------------------------------------------------------------------
export const extraFields = ["page", "limit"];
export default function OrganizationList(){
    const [searchParams] = useSearchParams();
    const { organizations, total }:{ organizations: Organization[], total: number } = useLoaderData();
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssContent pb8rem">
            <div className = "mt-2">
                <Link className = {"btn btn-outline-primary pointer position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                   {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <Link children = "Add" className = "btn btn-outline-primary float-end" to = "Add"/>
            </div>
            {!organizations.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Organization Name</th>
                            <th>Website</th>
                            <th>Business Phone</th>
                            <th>Fax</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {organizations.map((org: Organization, key: number) => 
                        <tr key = {key}>
                            <td>{org.name}</td>
                            <td>{org.website?<a href = {org.website} target = "_blank" rel = "noreferrer">{org.website}</a>:<></>}</td>
                            <td>{org.phoneNumber?<a href = {`tel:+1${org.phoneNumber.replace(/-/g, "")}${org.extension?`,${org.extension}`:""}`}>{org.phoneNumber}{org.extension?` Ext. ${org.extension}`:null}</a>:<></>}</td>
                            <td>{org.fax?<a href = {"fax:+1" + org.fax.replace(/-/g, "")}>{org.fax}</a>:<></>}</td>
                            <td><Link children = "Detail" className = "btn btn-outline-primary" to = {String(org.id)}/></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>}
            {total > 0? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}